import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1" id="top" data-testid="home-page">
      <Helmet>
        <title>Leelanau Dock & Hoist | Suttons Bay, Michigan</title>
        <meta
          property="og:title"
          content="Leelanau Dock & Hoist | Suttons Bay, Michigan"
        />
      </Helmet>
      <Navigation></Navigation>

      {/* =================== HERO =================== */}
      <section className="hero-section" data-testid="hero-section">
        <div className="hero-diagonal-split home-thq-hero-diagonal-split-elm">
          <div className="hero-content-left">
            <div className="hero-text-container">
              <span className="hero-eyebrow" data-testid="hero-eyebrow">
                <span className="hero-eyebrow-dot" />
                Family owned · Suttons Bay, Michigan
              </span>
              <h1
                className="hero-title home-hero-title"
                data-testid="hero-title"
              >
                Professional Dock &amp; Hoist Service
                <br />
                in Leelanau County
              </h1>
              <p
                className="home-hero-subtitle hero-subtitle"
                data-testid="hero-subtitle"
              >
                Installation, seasonal service, hoist sales, repair, and
                offsite winter storage — family owned and operated out of
                Suttons Bay, Michigan.
              </p>
              <div className="hero-cta-group">
                <a href="#contact-form" data-testid="hero-cta-primary">
                  <div className="btn-lg btn btn-primary">
                    <span>Request a Quote</span>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ marginLeft: '6px' }}
                    >
                      <path d="M5 12h14M13 5l7 7-7 7" />
                    </svg>
                  </div>
                </a>
                <a
                  href="tel:+12314926114"
                  className="hero-call-link"
                  data-testid="hero-phone-link"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  <span>231-492-6114</span>
                </a>
              </div>
              <div className="hero-trust-row">
                <div className="hero-trust-item">
                  <span className="hero-trust-value">Family owned</span>
                  <span className="hero-trust-label">Suttons Bay, MI</span>
                </div>
                <div className="hero-trust-divider" />
                <div className="hero-trust-item">
                  <span className="hero-trust-value">Shore Station</span>
                  <span className="hero-trust-label">qualified installer</span>
                </div>
                <div className="hero-trust-divider" />
                <div className="hero-trust-item">
                  <span className="hero-trust-value">Leelanau +</span>
                  <span className="hero-trust-label">surrounding areas</span>
                </div>
              </div>
            </div>
          </div>
          <div className="hero-content-right">
            <img
              alt="Leelanau County waterfront with dock and boat hoist"
              src="/bed-dock-flip.jpg"
              className="hero-image home-thq-hero-image-elm"
            />
          </div>
        </div>
      </section>

      {/* =================== SERVICES =================== */}
      <section
        id="services"
        className="services-section"
        data-testid="services-section"
      >
        <div className="container">
          <div className="section-header">
            <span className="section-eyebrow">What we do</span>
            <h2 className="section-title">Full-service waterfront care</h2>
            <p className="section-content section-header-sub">
              Everything you need to get on the water in the spring, stay safe
              all summer, and button things up before winter.
            </p>
          </div>
          <div className="services-grid">
            <div className="service-card" data-testid="service-card-dock-install">
              <div className="service-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 18h18M5 18V9m4 9V9m4 9V9m4 9V9m4 9V9M2 9h20L12 3 2 9Z" />
                </svg>
              </div>
              <h3 className="section-subtitle">Dock Installation</h3>
              <p className="section-content">
                We set and level every section precisely for your shoreline.
              </p>
            </div>
            <div className="service-card" data-testid="service-card-hoist-sales">
              <div className="service-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 21h16M6 21V9l6-4 6 4v12M9 21v-6h6v6" />
                </svg>
              </div>
              <h3 className="section-subtitle">Boat Hoist Sales &amp; Install</h3>
              <p className="section-content">
                Vertical, cantilever, hydraulic — sized and installed for your
                boat, your lake, and your water depth.
              </p>
            </div>
            <div className="service-card" data-testid="service-card-seasonal">
              <div className="service-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <path d="M8 2v4M16 2v4M3 10h18M8 14h.01M12 14h.01M16 14h.01" />
                </svg>
              </div>
              <h3 className="section-subtitle">Seasonal Install &amp; Removal</h3>
              <p className="section-content">
                Reliable spring-in / fall-out service booked on your schedule,
                with enough lead time to beat the freeze.
              </p>
            </div>
            <div className="service-card" data-testid="service-card-repair">
              <div className="service-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.1-3.1a6 6 0 0 1-8.3 7.1l-7.9 7.9a1 1 0 0 1-3-3l7.9-7.9a6 6 0 0 1 7.1-8.3z" />
                </svg>
              </div>
              <h3 className="section-subtitle">Repair &amp; Maintenance</h3>
              <p className="section-content">
                Cables, winches, wheels, rollers, decking, posts — we fix what
                winter and wave action wear out.
              </p>
            </div>
            <div className="service-card" data-testid="service-card-storage">
              <div className="service-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 9l9-6 9 6v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9z" />
                  <path d="M9 22V12h6v10" />
                </svg>
              </div>
              <h3 className="section-subtitle">Winter Storage</h3>
              <p className="section-content">
                Pull it, haul it, and stack it safely off the ice in our
                <strong> secure offsite storage</strong>. Ready to reinstall
                right when you want to splash back in.
              </p>
            </div>
            <div className="service-card" data-testid="service-card-transport">
              <div className="service-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
                  <circle cx="7" cy="18" r="2" />
                  <circle cx="17" cy="18" r="2" />
                </svg>
              </div>
              <h3 className="section-subtitle">Barge &amp; Road Transport</h3>
              <p className="section-content">
                On-water barge service and road haul-and-deliver available
                for docks, hoists, and shoreline equipment — anywhere on the
                peninsula.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* =================== ABOUT =================== */}
      <section
        id="about"
        className="about-section"
        data-testid="about-section"
      >
        <div className="container">
          <div className="about-wrapper">
            <div className="about-copy">
              <span className="section-eyebrow" data-testid="about-eyebrow">
                About
              </span>
              <h2 className="section-title about-title" data-testid="about-title">
                Meet the Owner.
              </h2>
              <p className="section-content about-lead">
                Leelanau Dock &amp; Hoist is a <strong>family-owned and
                operated</strong> business run by <strong>Ben Bakker</strong>
                — born and raised in Leelanau County and based right here
                out of Suttons Bay.
              </p>
              <p className="section-content about-body">
                Ben is a U.S. Marine Corps veteran and a
                <strong> Shore Station qualified installer</strong> — the
                same discipline, training, and attention to detail show up
                on every shoreline we work.
              </p>
              <p className="section-content about-body">
                We&apos;re a local, experienced crew focused on dependable
                work: honest quotes, careful installs, and a team that shows
                up when we say we will. From the first spring set to the last
                fall pull before the ice, every dock and hoist gets the same
                attention we&apos;d give our own.
              </p>
              <div className="about-credentials" data-testid="about-credentials">
                <div className="about-credential">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M12 2 4 6v6c0 5 3.5 9 8 10 4.5-1 8-5 8-10V6l-8-4Z" />
                  </svg>
                  <div className="about-credential-text">
                    <span className="about-credential-title">U.S. Marine Corps veteran</span>
                    <span className="about-credential-sub">Discipline &amp; attention to detail</span>
                  </div>
                </div>
                <div className="about-credential">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="m9 11 3 3L22 4" />
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                  </svg>
                  <div className="about-credential-text">
                    <span className="about-credential-title">Shore Station qualified</span>
                    <span className="about-credential-sub">Factory-trained installer</span>
                  </div>
                </div>
                <div className="about-credential">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                  <div className="about-credential-text">
                    <span className="about-credential-title">Family owned &amp; operated</span>
                    <span className="about-credential-sub">Suttons Bay, Leelanau County</span>
                  </div>
                </div>
              </div>
              <div className="about-signoff">
                <div className="about-signoff-line" />
                <span className="about-signoff-text">
                  Local. Professional. On time.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =================== GALLERY =================== */}
      <section
        id="gallery"
        className="gallery-section"
        data-testid="gallery-section"
      >
        <div className="container">
          <div className="section-header section-header-light">
            <span className="section-eyebrow section-eyebrow-light">
              Recent work
            </span>
            <h2 className="section-title section-title-light">
              A look at some of our recent projects
            </h2>
          </div>
          <div className="gallery-grid">
            <figure className="gallery-item gallery-item-large" data-testid="gallery-item-1">
              <img src="/gallery-1.jpg" alt="Recent Leelanau Dock & Hoist project" />
            </figure>
            <figure className="gallery-item" data-testid="gallery-item-2">
              <img src="/gallery-2.jpg" alt="Recent Leelanau Dock & Hoist project" />
            </figure>
            <figure className="gallery-item" data-testid="gallery-item-3">
              <img src="/gallery-3.jpg" alt="Recent Leelanau Dock & Hoist project" />
            </figure>
            <figure className="gallery-item gallery-item-large" data-testid="gallery-item-4">
              <img src="/gallery-4.jpg" alt="Recent Leelanau Dock & Hoist project" />
            </figure>
          </div>
        </div>
      </section>

      {/* =================== PROCESS =================== */}
      <section className="process-section" data-testid="process-section">
        <div className="container">
          <div className="section-header">
            <span className="section-eyebrow">How it works</span>
            <h2 className="section-title">Four simple steps</h2>
            <p className="section-content section-header-sub">
              From first call to the last pull-out of the year.
            </p>
          </div>
          <div className="process-steps">
            <div className="step-item">
              <div className="step-number">
                <span>01</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Reach out</h3>
                <p className="section-content">
                  Send the form or call. Tell us what you have, what you want,
                  and where you are on the water.
                </p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">
                <span>02</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Walk the shoreline</h3>
                <p className="section-content">
                  We meet on site, look at depth and bottom, and put together
                  an honest, written estimate.
                </p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">
                <span>03</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Schedule the install</h3>
                <p className="section-content">
                  Pick a window that works for your season. We&apos;ll arrive
                  on time, with the right gear and crew.
                </p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">
                <span>04</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Season after season</h3>
                <p className="section-content">
                  In every spring. Out every fall. Repair when needed. One
                  phone number for the whole life of your setup.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =================== SERVICE AREA =================== */}
      <section
        id="service-area"
        className="area-section"
        data-testid="service-area-section"
      >
        <div className="container">
          <div className="area-grid">
            <div className="area-copy">
              <span className="section-eyebrow">Service area</span>
              <h2 className="section-title">
                Leelanau County
                <br />
                &amp; surrounding areas.
              </h2>
              <p className="section-content area-body">
                Based in Suttons Bay, we cover the entire Leelanau
                peninsula — from the village beaches to the quiet inland
                lakes — plus nearby shorelines in the surrounding areas.
              </p>
              <p className="area-note section-content">
                Not in Leelanau County? Give us a call — if you&apos;re
                nearby, chances are we can help.
              </p>
            </div>
            <div className="area-card-wrap">
              <div className="area-card">
                <div className="area-card-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div className="area-card-title">Leelanau County, MI</div>
                <div className="area-card-sub">
                  Home base · Suttons Bay
                </div>
                <div className="area-card-divider" />
                <a
                  href="tel:+12314926114"
                  className="area-card-contact"
                  data-testid="service-area-phone"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  <span>231-492-6114</span>
                </a>
                <a
                  href="mailto:Ben45service@gmail.com"
                  className="area-card-contact"
                  data-testid="service-area-email"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="m22 6-10 7L2 6" />
                  </svg>
                  <span>Ben45service@gmail.com</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =================== CONTACT =================== */}
      <section id="contact-form" className="contact-section" data-testid="contact-section">
        <div className="container">
          <div className="contact-card-wrapper">
            <div className="contact-info-panel">
              <span className="contact-urgency-pill" data-testid="contact-urgency-pill">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <path d="M8 2v4M16 2v4M3 10h18" />
                </svg>
                Booking Now
              </span>
              <h2 className="section-title">Request a quote</h2>
              <p className="section-content contact-intro">
                Spring install and fall removal slots fill up fast — get on
                the schedule before the rush.
              </p>
              <p className="section-content contact-sub">
                Fill out the form and your request goes straight to Ben&apos;s
                inbox. Prefer a phone call? That works too.
              </p>
              <div className="contact-details">
                <a
                  href="tel:+12314926114"
                  className="detail-item"
                  data-testid="contact-phone-link"
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  <span>231-492-6114</span>
                </a>
                <a
                  href="mailto:Ben45service@gmail.com"
                  className="detail-item"
                  data-testid="contact-email-link"
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="m22 6-10 7L2 6" />
                  </svg>
                  <span>Ben45service@gmail.com</span>
                </a>
                <div className="detail-item">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  <span>Suttons Bay, MI · Serving all of Leelanau County</span>
                </div>
              </div>
            </div>
            <form
              id="quoteForm"
              action="#"
              method="POST"
              className="contact-form-element"
              data-testid="contact-form"
              noValidate
            >
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="name">Full name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    placeholder="Jane Angler"
                    data-testid="contact-input-name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    placeholder="you@example.com"
                    data-testid="contact-input-email"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="(231) 555-0000"
                    data-testid="contact-input-phone"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="service">Service interest</label>
                  <select
                    id="service"
                    name="service"
                    required
                    data-testid="contact-input-service"
                    defaultValue=""
                  >
                    <option value="" disabled>
                      Select a service
                    </option>
                    <option value="Dock Installation">Dock Installation</option>
                    <option value="Hoist Sales & Install">Hoist Sales &amp; Install</option>
                    <option value="Seasonal Install / Removal">Seasonal Install / Removal</option>
                    <option value="Repair & Maintenance">Repair &amp; Maintenance</option>
                    <option value="Winter Storage">Winter Storage</option>
                    <option value="Shoreline Consult">Shoreline Consult</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="full-width form-group">
                  <label htmlFor="location">Lake / shoreline location</label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    placeholder="e.g. Lake Leelanau, Glen Lake, Suttons Bay"
                    data-testid="contact-input-location"
                  />
                </div>
                <div className="full-width form-group">
                  <label htmlFor="message">Project details</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    placeholder="Tell us about your dock, hoist, boat, and timing..."
                    data-testid="contact-input-message"
                  ></textarea>
                </div>
                {/* Honeypot field — hidden from users, catches bots */}
                <div
                  aria-hidden="true"
                  style={{
                    position: 'absolute',
                    left: '-10000px',
                    width: '1px',
                    height: '1px',
                    overflow: 'hidden',
                  }}
                >
                  <label htmlFor="website">Website (leave blank)</label>
                  <input
                    type="text"
                    id="website"
                    name="website"
                    tabIndex={-1}
                    autoComplete="off"
                  />
                </div>
                <button
                  type="submit"
                  className="btn-lg btn btn-primary full-width"
                  data-testid="contact-submit"
                >
                  <span className="contact-submit-label">Send Request</span>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ marginLeft: '8px' }}
                  >
                    <path d="M5 12h14M13 5l7 7-7 7" />
                  </svg>
                </button>
                <p
                  id="formFeedback"
                  className="form-feedback"
                  data-testid="contact-form-feedback"
                  role="status"
                  aria-live="polite"
                ></p>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* =================== CTA BANNER removed — copy moved into contact panel =================== */}

      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<script defer data-name="leelanau-dock-logic">
(function(){
  var API_BASE = ${JSON.stringify(process.env.REACT_APP_BACKEND_URL || '')}
  var RECIPIENT = "Ben45service@gmail.com"

  var form = document.getElementById("quoteForm")
  var feedback = document.getElementById("formFeedback")
  var submitBtn = form ? form.querySelector('button[type="submit"]') : null
  var submitLabel = submitBtn ? submitBtn.querySelector('.contact-submit-label') : null

  function setFeedback(text, color){
    if (!feedback) return
    feedback.textContent = text
    feedback.style.color = color || ""
  }

  function setSubmitting(isSubmitting, label){
    if (!submitBtn) return
    submitBtn.disabled = isSubmitting
    submitBtn.style.opacity = isSubmitting ? "0.75" : ""
    if (submitLabel && label) submitLabel.textContent = label
  }

  function buildMailtoFallback(values){
    var subject = "Quote request — " + values.service + (values.location ? " (" + values.location + ")" : "")
    var bodyLines = [
      "Hi Ben,",
      "",
      "I'd like a quote for: " + values.service,
      values.location ? "Location: " + values.location : null,
      "",
      "Name: " + values.name,
      "Email: " + values.email,
      values.phone ? "Phone: " + values.phone : null,
      "",
      values.message ? "Details:" : null,
      values.message ? values.message : null,
      "",
      "Thanks!"
    ].filter(Boolean).join("\\n")
    return "mailto:" + RECIPIENT +
      "?subject=" + encodeURIComponent(subject) +
      "&body=" + encodeURIComponent(bodyLines)
  }

  if (form) {
    form.addEventListener("submit", function(e){
      e.preventDefault()
      var data = new FormData(form)
      var values = {
        name: (data.get("name") || "").toString().trim(),
        email: (data.get("email") || "").toString().trim(),
        phone: (data.get("phone") || "").toString().trim(),
        service: (data.get("service") || "").toString().trim(),
        location: (data.get("location") || "").toString().trim(),
        message: (data.get("message") || "").toString().trim(),
        website: (data.get("website") || "").toString().trim()
      }

      if (!values.name || !values.email || !values.service) {
        setFeedback("Please fill in your name, email, and service.", "#c0392b")
        return
      }

      var originalLabel = submitLabel ? submitLabel.textContent : "Send Request"
      setSubmitting(true, "Sending…")
      setFeedback("", "")

      if (!API_BASE) {
        // No backend URL configured — fall back to mailto
        window.location.href = buildMailtoFallback(values)
        setSubmitting(false, originalLabel)
        return
      }

      fetch(API_BASE + "/api/quote", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values)
      })
      .then(function(res){
        return res.json().then(function(body){ return { ok: res.ok, status: res.status, body: body } })
      })
      .then(function(result){
        if (result.ok && (result.body.status === "sent" || result.body.status === "ok")) {
          form.reset()
          setSubmitting(false, "Request sent ✓")
          setFeedback("Thanks! Your request is on its way to Ben. He'll be in touch soon.", "#0b7a5b")
          setTimeout(function(){ setSubmitting(false, originalLabel) }, 4000)
        } else {
          var detail = (result.body && result.body.detail) ? result.body.detail : "Something went wrong."
          setSubmitting(false, originalLabel)
          setFeedback(detail + " Opening email as a backup…", "#c0392b")
          setTimeout(function(){ window.location.href = buildMailtoFallback(values) }, 800)
        }
      })
      .catch(function(){
        setSubmitting(false, originalLabel)
        setFeedback("Couldn't reach the server. Opening your email app as a backup…", "#c0392b")
        setTimeout(function(){ window.location.href = buildMailtoFallback(values) }, 800)
      })
    })
  }

  // Smooth-scroll for same-page anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor){
    anchor.addEventListener("click", function (e) {
      var href = this.getAttribute("href")
      if (!href || href === "#") return
      var target = document.querySelector(href)
      if (target) {
        e.preventDefault()
        target.scrollIntoView({ behavior: "smooth", block: "start" })
        try { history.pushState(null, "", href) } catch (err) { /* noop */ }
      }
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
